























// Type Original is only defined in PHP; Vue components do not require it currently.

import Vue from "vue";
import {Pricing} from "../../module/Deals/view/vue/domain/Pricing";

export default Vue.extend( {
  name     : 'Pricing',
  props    : {
    pricing : {
      type    : Object as () => Pricing | null,
      default : null
    },
    type : {
      type    : String,
      default : 'default'
    },
  },
  computed: {
    isSimple(): boolean {
      return this.type === 'simple';
    },
  },
  methods: {
    openPriceModal(event: Event, price: string) {
      window.priceInformationModal(event, price);
    }
  }
} )
